import { useEffect, useState } from 'react';

import { markDocumentsSeen, readDocumentsSeenAt } from '~/session/documentVisits';

interface Visit {
  clientId: number;
  /** A visita anterior a esta, lida ao abrir o feed; o "Novo" compara com ela a tela inteira. */
  seenAt: number | null;
}

function visitOf(clientId: number): Visit {
  return { clientId, seenAt: readDocumentsSeenAt(clientId) };
}

/**
 * A visita anterior ao feed da empresa, e a gravação desta. O instante da visita anterior é lido
 * uma vez ao abrir (e de novo ao trocar de empresa), para que o "Novo" não suma enquanto a pessoa
 * lê; o instante atual é gravado ao sair da tela, ao trocar de empresa (na anterior) e ao fechar
 * ou esconder o app, porque o `pagehide` não chega sempre no celular.
 */
export function useLastVisit(clientId: number): number | null {
  const [visit, setVisit] = useState(() => visitOf(clientId));
  if (visit.clientId !== clientId) {
    setVisit(visitOf(clientId));
  }

  useEffect(() => {
    const markSeen = (): void => markDocumentsSeen(clientId);
    const markSeenWhenHidden = (): void => {
      if (document.visibilityState === 'hidden') markSeen();
    };
    window.addEventListener('pagehide', markSeen);
    document.addEventListener('visibilitychange', markSeenWhenHidden);
    return () => {
      window.removeEventListener('pagehide', markSeen);
      document.removeEventListener('visibilitychange', markSeenWhenHidden);
      markSeen();
    };
  }, [clientId]);

  return visit.seenAt;
}
